<template>


  <h3>
    <span v-if="isPoll">{{ debate.thesis }}</span>
    <span @click="openDebate" class="h3-link" v-else>{{ debate.thesis }}</span>
  </h3>

  <!-- <div class="top-bar">
    <div class="author" v-if="!isQuiz">
      <figure
        @click="openProfile(debate.user)"
        class="author-avatar"
        :style="{ borderColor: debate.user.statusColor, height: '22px', width: '22px'}"
      >
        <img
          v-if="debate.user && debate.user.avatarObject"
          :src="debate.user.avatarObject.thumb.location"
          :style="{height: '22px', width: '22px' }"
        />
        <template v-for="role in debate.user.roles" v-bind:key="role.name">
          <span
            v-if="role.name === 'VERIFIED'"
            class="checkmark"
            :style="{ backgroundColor: debate.user.checkmarkColor }"
          >
            <SvgElement name="check-icon" />
          </span>
        </template>
</figure>
<div class="author-rest">
  <div class="poll-author-name" @click="openProfile(debate.user)">
    {{ debate.user.name }}
  </div>
</div>
</div>

<span class="blue-button font-size-s" v-if="!isSidePanel && !isPoll && false" @click="onShowSidePanel(debate)">
  {{ $t("View poll") }}
</span>
</div> -->
  <div
    v-if="embedPlacementData && embedPlacementData.allowImagesForPoll == 1 && debate.backgroundImageObject && debate.backgroundImageObject.small"
    class="debate-image">
    <img :src="debate.backgroundImageObject.small.location" />
  </div>

  <div class="mid-bar">
    <span v-if="debate.isClosed && !isQuiz">
      {{ $t("Poll ended") }} {{ formatDate(debate.endedAt) }}
    </span>
    <span v-if="!debate.isClosed">
      <span v-if="debate.endedAt && !isQuiz">
        {{
          $t(debate.remainingDays !== "today" ? "Poll ends in" : "Poll ends ")
        }}
        {{
          debate.remainingDays
            .replace("days", $t("days"))
            .replace("today", $t("today"))
            .replace("day", $t("day"))
        }}
        &bull;
      </span>
      <span v-if="debate.votedSideId">
        <span v-if="
          isInfinite() && votingStarted && !isSidePanel && !showEmailModal
        ">
          <template v-if="isQuiz">
            <template v-if="debate.votedSide() && debate.votedSide().isCorrect">Correct answer!</template>
            <template v-else-if="debate.votedSide()">Incorrect answer!</template>
            Next question loading
          </template>
          <template v-else>Next poll loading</template>
          &nbsp;
          <CountdownCircle />
        </span>
        <span v-else-if="isQuiz">
          <template v-if="debate.votedSide().isCorrect">Correct answer!</template>
          <template v-else>Incorrect answer!</template>
        </span>
        <span v-else-if="false" class="text-button underlined"
          @click="initDebate(debateHistory[debateHistory.length - 1])">{{ $t("See next poll") }}</span>
      </span>
      <span v-else-if="isQuiz">
        {{ $t("Select the correct answer below") }}:
      </span>
      <span v-else>
        {{ $t("Vote below") }}
      </span>
    </span>
  </div>

  <div v-if="hasSideImage" class="debatePreviewSides debatePreviewVotes">
    <div v-for="elSides in debate.sides" :key="elSides.id" class="side vote-container">
      <div @click="!debate.votedSideId && !debate.isClosed && onVote(debate, elSides)" class="vote-image-container">
        <img alt="img" :src="elSides.sideBackgroundImageObject?.large?.location || 'https://placehold.co/400'" />
        <div class="vote-overlay">
          <div class="vote-text">{{ elSides.text }}</div>
          <div className="vote-percentage">
          {{ elSides.percent }}%
        </div>
        </div>
      </div>
      <div class="check-icon">
        <SvgElement :pathFill="debate.votedSideId === elSides.id ? '#219653' : '#b8b8b8'" name="vote-icon" />
      </div>
    </div>
  </div>

  <ul class="sides" v-if="!hasSideImage && !debate.isClosed && !debate.votedSideId">
    <li v-for="side in debate.sides" v-bind:key="side.id">
      <span @click="onVote(debate, side)" class="a">
        {{ side.text }}
      </span>
    </li>
  </ul>

  <ul class="sides-closed" v-if="!hasSideImage && (debate.isClosed || debate.votedSideId)">
    <li v-for="side in debate.sides" :class="{
      winner: debate.isClosed && side.isMostVoted,
      voted: side.id === debate.votedSideId,
      quizzed: debate.isQuiz,
      correct: !!side.isCorrect,
      incorrect: !side.isCorrect,
    }" :style="{ borderLeftColor: side.sideColor }" v-bind:key="side.id">
      <div class="full-bar" :style="{ backgroundColor: side.sideColor }"></div>
      <div class="overlay" :style="{ width: side.percent + '%', backgroundColor: side.sideColor }"></div>
      <div class="text">
        <SvgElement v-if="debate.votedSideId === side.id" :pathFill="side.sideColor" name="vote-icon" />
        {{ side.text }}
      </div>
      <div class="percent">
        <span>{{ side.percent }}%</span>
        <a class="side-link" :href="side.link.trim().startsWith('http')
          ? side.link
          : `http://${side.link}`
          " target="_blank" v-if="side.link">
          <SvgElement name="arrow-right-icon" />
        </a>
      </div>
    </li>
  </ul>
</template>

<script>
import CountdownCircle from "./CountdownCircle";
import SvgElement from "./SvgElement";

export default {
  name: "DebateMainInfo",
  data() {
    return {
      hasSideImage: false, // Default value
    };
  },
  props: {
    debate: {
      type: Object,
      default: null,
    },
    isSidePanel: {
      type: Boolean,
      default: false,
    },
    isDebateFeed: {
      type: Boolean,
      default: false,
    },
  },
  inject: [
    "isPoll",
    "isQuiz",
    "onVote",
    "initDebate",
    "isInfinite",
    "feedDebate",
    "openProfile",
    "sidePanelTab",
    "debateHistory",
    "votingStarted",
    "setFeedDebate",
    "showEmailModal",
    "onShowSidePanel",
    "embedPlacementData"
  ],
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString("en-US", {
        month: "short",
        day: "numeric",
      });
    },
    openDebate() {
      if (this.isDebateFeed) {
        this.setFeedDebate(this.debate);
      } else {
        this.onShowSidePanel(this.debate);
      }
    },
  },
  components: {
    SvgElement,
    CountdownCircle,
  },
  watch: {
    debate: {
      handler(newVal) {
        if (newVal?.sides?.length > 0) {
          this.hasSideImage = newVal.sides.some(
            (side) => Boolean(side.sideBackgroundImageObject?.large?.location)
          );
        }
      },
      deep: true, // Ensures nested properties are tracked
    },
  },
  mounted() {
    if (this.debate?.sides?.length > 0) {
      this.hasSideImage = this.debate.sides.findIndex((side) =>
        Boolean(side.sideBackgroundImageObject?.large.location)
      ) !== -1;
    }
    if (window.location.href.indexOf("voted-poll") !== -1) {
      const pollId = parseInt(
        new URLSearchParams(window.location.search).get("voted-poll"),
      );
      const sideId = parseInt(
        new URLSearchParams(window.location.search).get("side-id"),
      );

      if (this.debate.id === pollId) {
        const side = this.debate.sides.find((side) => side.id === sideId);

        if (side) {
          this.onVote(this.debate, side);
        }
      }
    }
  },
};
</script>
